/**
 * Kandydat na klucz zespołu, wyprowadzony z nazwy — **podpowiedź, nie reguła**.
 *
 * ⛔ To nie jest kopia walidatora serwera i nie wolno jej za taką uważać. Serwer rozstrzyga,
 * czy klucz przechodzi, i odmawia kodem niosącym wzorzec w argumentach; tutaj chodzi wyłącznie
 * o to, żeby admin nie musiał wymyślać symbolu od zera. Kopia reguły serwera na froncie
 * rozjechała się już raz i klient dwa razy przeczytał nieprawdę — próg długości hasła
 * (dec. 153, zmierzone na produkcji 2026-08-22).
 *
 * ⚠ Ogonki zdejmuje NFD plus **jawna mapa** dla `ł`: ta litera nie rozkłada się przez NFD, więc
 * bez mapy „Płatności" dałoby `p-atnosci` (spec 12A.3, ta sama pułapka co przy szukaniu).
 *
 * Pusty wynik (nazwa z samych znaków obcych) zostaje pusty — wtedy człowiek wpisuje klucz sam,
 * zamiast dostać wymyślony za niego.
 */
export function suggestTeamKey(name: string): string {
  return name
    .toLowerCase()
    .replaceAll('ł', 'l')
    .normalize('NFD')
    .replaceAll(/[̀-ͯ]/gu, '')
    .replaceAll(/[^a-z0-9]+/gu, '-')
    .replace(/^-+|-+$/gu, '')
    .slice(0, 64)
    .replace(/-+$/u, '');
}
